import * as types from './mutation-types'

export const loadOrders = ({ commit, dispatch, state }) => {
     return new Promise((resolve, reject) => {
          window.axios.get('customer/orders').then((response) => {
               commit(types.LOAD_ORDERS, response.data)
               resolve(response)
          }).catch(err => {
               reject(err)
          })
     })
}

export const loadOrderStatus = ({ commit, dispatch, state }) => {
     return new Promise((resolve, reject) => {
          window.axios.get('customer/get/status/orders').then((response) => {
               commit(types.LOAD_ORDERS_STATUS, response.data)
               resolve(response)
          }).catch(err => {
               reject(err)
          })
     })
}

export const loadOrder = ({ commit, dispatch, state },id) => {
     return new Promise((resolve, reject) => {
          window.axios.get(`customer/${id}/order`).then((response) => {
              // commit(types.LOAD_CATEGORIES, response.data)
               resolve(response)
          }).catch(err => {
               reject(err)
          })
     })
}

